<template>
  <div class="drink-container">
    <div class="title">喝水记录</div>
    <div class="record-list">
      <div class="record-item" v-for="(item, index) in data" :key="index">
        <div class="iconfont icon-cup"></div>
        <div>
          <div class="time">{{ item.created_at | filterTime }}</div>
          <div class="text">纯净水</div>
        </div>
        <div class="space"></div>
        <div
          class="color"
          v-if="cupType == 1"
          :style="{ backgroundColor: dealColor(item.water_color) }"
        ></div>
        <div class="ml">{{ item.water_volume }}ml</div>
      </div>
    </div>
    <div class="not-more" v-if="!data.length">
      <img
        class="not-img"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/88a483aa8e15e747cad808fd56bae7d6.png"
        alt=""
      />
      <div>当前暂无喝水记录，</div>
      <div>让我们开始打卡吧～</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    cupType: {
      type: Number,
      default: 1
    }
  },
  filters: {
    filterTime(str) {
      let time = (str && str.slice(11, 16)) || ''
      return time
    }
  },
  data() {
    return {}
  },
  methods: {
    dealColor(color) {
      if (color == 'rgba(0,0,0,0)') {
        color = 'rgba(153,153,153,0.6)'
      }
      return color
    }
  }
}
</script>
<style lang="scss" scoped>
.drink-container {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 22px;
    margin-bottom: 16px;
  }
  .record-list {
    .record-item {
      padding: 10px 20px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      .iconfont {
        margin-right: 13px;
        font-size: 24px;
        color: #979797;
      }
      .time {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.6);
        line-height: 20px;
      }
      .text {
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.6);
        line-height: 14px;
      }
      .space {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
      }
      .color {
        width: 16px;
        height: 4px;
        background: #999999;
        margin-right: 10px;
      }
      .ml {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.5);
        line-height: 20px;
      }
    }
    .record-item:nth-child(2n + 1) {
      background: #f9f9f9;
      border-radius: 8px;
    }
  }
}
.not-more {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.5);
  line-height: 20px;
  .not-img {
    width: 50px;
    margin-bottom: 20px;
  }
}
</style>
